import React from "react";
import ReactQuill from "react-quill";

function BoardDocumentEditor({
  summary,
  modules,
  formats,
  onChange,
  isPermission,
  isMobile,
  isLoadingDocument,
  isPending,
}) {
  return (
    <div className="text-editor" style={{ position: "relative" }}>
      {(isLoadingDocument || isPending) && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0.6)",
            zIndex: 2,
            fontSize: "16px",
            color: "#444",
            pointerEvents: "none",
          }}
        >
          {isLoadingDocument ? "Loading..." : "Saving..."}
        </div>
      )}
      <ReactQuill
        value={summary}
        modules={modules}
        formats={formats}
        className="react-quill-description"
        onChange={onChange}
        placeholder={isPermission ? "Type Here..." : ""}
        readOnly={!isPermission}
        style={{
          height: isMobile ? "170px" : "calc(96vh - 170px)",
          zIndex: 1,
          cursor: isPermission ? "text" : "default",
        }}
      />
    </div>
  );
}

export default React.memo(BoardDocumentEditor);
